import "@hotwired/turbo-rails"
import "./controllers"

import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.close_drawer = function () {
  const el = document.getElementById(this.getAttribute("target"))
  if (!el) return

  if (el.dataset.controller?.includes("modal")) {
    el.dispatchEvent(new CustomEvent("modal:close", { bubbles: false }))
  } else {
    el.dispatchEvent(new CustomEvent("drawer:close", { bubbles: false }))
  }
}
